import { graphql } from "relay-runtime"

export const PatientAllergiesOutputFragment = graphql`
  fragment PatientAllergiesOutputFragment on PatientAllergiesOutput {
    id
    status
    allergies {
      id
      comment
      icdDiagnosis {
        id
        isAssociation
        diagnosisCode
        primaryCode
        secondaryCode
        associationType
        text
      }
    }
  }
`
